/*
 *
 * PciNeedHelpModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
*/

import { connect } from 'react-redux'
import PciNeedHelpModal from './PciNeedHelpModal'
import { doHidePopup } from 'Store/actions/popup'
import { doNeedSupport } from 'Route/Pci/modules/PciActions'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup()),
  doNeedSupport: (data) => dispatch(doNeedSupport(data))
})

const mapStateToProps = (state) => ({
  needSupport: nullSafe(() => state.Pci.needSupport, null),
  merchantData: nullSafe(() => state.userProfiling.profiling.merchant, {}),
  userData: nullSafe(() => state.userProfiling.profiling.user, {})
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PciNeedHelpModal)
